<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '添加模板' : '修改模板'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="渠道">
          <channel-selector
            placeholder="请选择"
            enableFullChannels
            @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange"
            ref="channelSelector"
          >
          </channel-selector>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="（仅为了方便在后台页面上区分不同模板，不会在游戏里展示）"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div>
            <el-tabs type="card" v-model="form.activeLanguageTabName">
              <el-tab-pane
                v-for="item in form.languageTemplates"
                :key="item.language"
                :name="item.language"
              >
                <span slot="label"><i v-if="item.title == ''" class="el-icon-info" style="margin-right: 5px"></i>{{`[${item.language}]`}}</span>
                <div>
                  <label style="display: block">{{
                    `[${item.language}] 标题：`
                  }}</label>
                  <el-input
                    v-model="item.title"
                    placeholder="（这个会在游戏里展示）"
                  ></el-input>
                </div>
                <div style="margin-top: 5px">
                  <label style="display: block">{{
                    `[${item.language}] 正文：`
                  }}</label>
                  <el-input
                    type="textarea"
                    rows="15"
                    v-model="item.content"
                    placeholder="（这个也会在游戏里展示）"
                  ></el-input>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form-item>
        <el-form-item v-if="!this.value.isCreate">
          <div style="color: red;">注意：修改模板会导致已发出的邮件的内容也受到影响，请谨慎使用！</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("../../util");

import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      visible: true,
      languages: [], // 所有的语言
      form: {
        channelId: "",
        name: "",
        activeLanguageTabName: "",
        languageTemplates: [], // 各个语言对应的模板（标题和正文）
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  components: {
    ChannelSelector,
  },

  async created() {
    // 查询语言集合
    await this.getLanguageList();

    if (this.value.isCreate) {
      // 为各个语言构建空模板
      await this.buildEmptyTemplatesForAllLanguages();
    } else {
      this.form.channelId = this.value.channelId;
      this.form.name = this.value.templateData.mailTemplateName;
      this.form.languageTemplates = this.value.templateData.languageTemplates;
      if (this.languages && this.languages.length > 0) {
        this.form.activeLanguageTabName = this.languages[0];
      }
    }
  },

  methods: {
    async onChannelSelectorReady() {
      if (!this.value.isCreate) {
        this.$refs.channelSelector.channelId = this.form.channelId;
      }
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    /**
     * 提交表单
     */
    submit() {
      if (this.form.channelId === "") {
        this.$alert("请选择渠道");
        return;
      }

      console.log("this.form.channelId:", this.form.channelId);

      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        let apiUrl = "";
        let requestBody = null;
        if (this.value.isCreate) {
          apiUrl = `${util.getBackendApiBase()}/v1/addMailTemplate`;
          requestBody = {
            channelId: this.form.channelId,
            mailTemplateName: this.form.name,
            mailTemplate: this.form.languageTemplates,
          };
        } else {
          apiUrl = `${util.getBackendApiBase()}/v1/updateMailTemplate`;
          requestBody = {
            mailTemplateId: this.value.templateData.mailTemplateId,
            channelId: this.form.channelId,
            mailTemplateName: this.form.name,
            mailTemplate: this.form.languageTemplates,
          };
        }

        let resData = (
          await axios.post(apiUrl, requestBody, {
            headers: {
              token: util.getLoginUserToken(),
            },
          })
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },

    /**
     * 为各个语言构建空模板
     */
    async buildEmptyTemplatesForAllLanguages() {
      for (let l of this.languages) {
        this.form.languageTemplates.push({
          language: l,
          title: "",
          content: "",
        });
      }

      if (
        this.form.languageTemplates &&
        this.form.languageTemplates.length > 0
      ) {
        this.form.activeLanguageTabName =
          this.form.languageTemplates[0].language;
      }
    },

    /**
     * 查询语言集合
     */
    async getLanguageList() {
      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/getLanguageList`,
          {},
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        if (resData.code != 10015) {
          this.$message.error(resData.message);
          return;
        }

        return;
      }

      if (resData.data.languageList) {
        for (let l of resData.data.languageList) {
          this.languages.push(l);
        }
      }
    },
  },
};
</script>